"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlipPosition = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
// this package animates an elements children to new positions using the flip
// method for smooth 60fps animations
//
// https://aerotwist.com/blog/flip-your-animations/

// TODO: remove in 5.x
class FlipPosition {
  constructor(parentEl) {
    (0, _defineProperty2.default)(this, "parentEl", void 0);
    (0, _defineProperty2.default)(this, "startMap", void 0);
    (0, _defineProperty2.default)(this, "endMap", void 0);
    (0, _defineProperty2.default)(this, "snapshotStart", () => {
      const children = [...this.parentEl.children];
      children.forEach(child => {
        this.startMap.set(child, child.getBoundingClientRect());
        // data-anim-state is to workaround a browser bug
        // should switch to react motion later
        if (child.getAttribute('data-anim-state') !== 'leave') {
          child.style.transition = 'none';
        }
      });
    });
    (0, _defineProperty2.default)(this, "snapshotEnd", transition => {
      const children = [...this.parentEl.children];
      children.forEach(child => {
        // measure forces layout
        this.endMap.set(child, child.getBoundingClientRect());
      });
      children.forEach(child => {
        const dx = this.endMap.get(child).left - this.startMap.get(child).left;
        const dy = this.endMap.get(child).top - this.startMap.get(child).top;
        // translate to old position
        if (dx === 0 && dy === 0) {
          return;
        }
        child.style.transform = "translate3d(".concat(-dx, "px, ").concat(-dy, "px, 0)");
      });

      // force layout
      this.parentEl.getBoundingClientRect();
      children.forEach(child => {
        child.style.transform = null;
        child.style.transition = transition ? transition : null;
        const onTransitionEnd = () => {
          child.style.transition = null;
          child.removeEventListener('transitionend', onTransitionEnd);
        };
        child.addEventListener('transitionend', onTransitionEnd);
      });
    });
    this.parentEl = parentEl;
    this.startMap = new WeakMap();
    this.endMap = new WeakMap();
  }
}
exports.FlipPosition = FlipPosition;